import { Button, Heading, Icon, Show, Text, VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { CircleDollarSignIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'router/routes';

export const OrderSummaryRefundedView = () => (
  <VStack bg='green.G700' textAlign='center' justifyContent='center' gap='16px' p='40px 16px'>
    <Icon
      as={CircleDollarSignIcon}
      boxSize='80px'
      color='green.500'
      backgroundColor='white'
      borderRadius='full'
    />
    <div>
      <Heading
        as='h1'
        variant={{ base: 'headingMedium', sm: 'headingLarge' }}
        mb='4px'
        color='white'
      >
        <FormattedMessage id='orderSummary.refunded.title' defaultMessage='Order was refunded' />
      </Heading>
      <Text textStyle='bodyLargeRegular' color='white'>
        <FormattedMessage
          id='orderSummary.refunded.descriptionFirstLine'
          defaultMessage='Your order was refunded.'
        />
      </Text>
      <Show above='md'>
        <Text textStyle='bodyLargeRegular' color='white' mt='0px'>
          <FormattedMessage
            id='orderSummary.refunded.descriptionSecondLine'
            defaultMessage='Please try again later'
          />
        </Text>
      </Show>
    </div>
    <Button
      variant='primaryMedium'
      bg='green.G0'
      borderColor='green.G0'
      _hover={{ bg: 'green.G200', borderColor: 'green.G200' }}
      textColor='dark.D900'
      as={Link}
      to={ROUTES.home}
    >
      <FormattedMessage id='orderSummary.refunded.button' defaultMessage='Back to homepage' />
    </Button>
  </VStack>
);
